import { render, staticRenderFns } from "./WFieldInput.vue?vue&type=template&id=623f5629&"
import script from "./WFieldInput.vue?vue&type=script&lang=ts&"
export * from "./WFieldInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports